import {
  FBI_EDIT_START,
  FBI_EDIT_NODE_END,
  FBI_VIEW_STATE_CUSTOM_PROP_SET,
} from 'actions/flowBlockInput';

export const INITIAL_STATE = {
  initialTab: null,
  onNotifyResponsesSubmit: null,
  custom: {},
};

export default function flowBlockInputViewStateReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case FBI_EDIT_START: {
      const {
        initialTab,
        onNotifyResponsesSubmit,
        custom = {},
      } = action.payload;

      return {
        ...state,
        initialTab,
        onNotifyResponsesSubmit,
        custom,
      };
    }
    case FBI_EDIT_NODE_END: {
      return {
        ...state,
        initialTab: null,
        onNotifyResponsesSubmit: null,
        custom: {},
      };
    }
    case FBI_VIEW_STATE_CUSTOM_PROP_SET: {
      const { propName, value } = action.payload;
      return {
        ...state,
        custom: {
          ...state.custom,
          [propName]: value,
        },
      };
    }
    default:
      return state;
  }
}
